import { createContext, useContext, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { AdminAuthModal } from "@/components/AdminAuthModal";

const Ctx = createContext(null);
export const useAdminAuth = () => useContext(Ctx);

export function AdminAuthProvider({ children }) {
  const navigate = useNavigate();
  const [authed, setAuthed] = useState(() => sessionStorage.getItem("des_admin_ok") === "1");
  const [open, setOpen] = useState(false);

  const openModal = useCallback(() => {
    if (sessionStorage.getItem("des_admin_ok") === "1") {
      setAuthed(true);
      navigate("/admin");
      return;
    }
    setOpen(true);
  }, [navigate]);

  const onSuccess = useCallback(() => {
    sessionStorage.setItem("des_admin_ok", "1");
    setAuthed(true);
    setOpen(false);
    navigate("/admin");
  }, [navigate]);

  return (
    <Ctx.Provider value={{ authed, openModal }}>
      {children}
      <AdminAuthModal open={open} onOpenChange={setOpen} onSuccess={onSuccess} />
    </Ctx.Provider>
  );
}
